<template>
    <svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.08282 4.5767C2.03815 3.9959 2.49737 3.5 3.07988 3.5H12.9201C13.5026 3.5 13.9619 3.9959 13.9172 4.5767L13.071 15.5767C13.0309 16.0977 12.5965 16.5 12.074 16.5H3.92603C3.40349 16.5 2.96905 16.0977 2.92898 15.5767L2.08282 4.5767Z"
            stroke="black"
            stroke-linejoin="round" />
        <path d="M14 6.5L15 6.5C16.6569 6.5 18 7.84315 18 9.5V10.5C18 12.1569 16.6569 13.5 15 13.5H13" stroke="black" stroke-linejoin="round" />
    </svg>
</template>
